import './Header-aff64597.css';

var classes = {"Header":"prc-Header-Header-RoCS8","HeaderItem":"prc-Header-HeaderItem-0wRcu","HeaderLink":"prc-Header-HeaderLink-2Q6pd"};

export { classes as default };
